module.exports = __webpack_public_path__ + "img/KUCE-04.743eb5f3.png";